
import { MainBuildingEnvelopeRenewals } from './1BuildingEnvelopeRenewals/Main';
import { gallerySectionBuildingEnvelopeRenewals } from './1BuildingEnvelopeRenewals/gallerySection';
import { overlaySectionBuildingEnvelopeRenewals } from './1BuildingEnvelopeRenewals/overlaySection';
import { servicesOverviewBuildingEnvelopeRenewals } from './1BuildingEnvelopeRenewals/servicesOverview';
import { featureDataBuildingEnvelopeRenewals } from './1BuildingEnvelopeRenewals/featureData';

import { MainServiceSectionCaulkingSealantRenewal } from './2Caulking&SealantRenewal/Main';
import { gallerySection } from './2Caulking&SealantRenewal/gallerySection';
import { overlaySectionCaulkingSealantRenewal } from './2Caulking&SealantRenewal/overlaySection';
import { servicesOverview } from './2Caulking&SealantRenewal/servicesOverview';
import { featureData } from './2Caulking&SealantRenewal/featureData';

import { featureDataCommercialExteriorPainting } from './3CommercialExteriorPainting/featureData';
import { servicesOverviewCommercialExteriorPainting } from './3CommercialExteriorPainting/servicesOverview';
import { overlaySectionCommercialExteriorPainting } from './3CommercialExteriorPainting/overlaySection';
import { gallerySectionCommercialExteriorPainting } from './3CommercialExteriorPainting/gallerySection';
import { MainCommercialExteriorPainting } from './3CommercialExteriorPainting/Main';

import { MainHighRiseMidRiseProjects } from './4HighRiseMidRiseProjects/Main';
import { gallerySectionHighRiseMidRiseProjects } from './4HighRiseMidRiseProjects/gallerySection';
import { overlaySectionHighRiseMidRiseProjects } from './4HighRiseMidRiseProjects/overlaySection';
import { servicesOverviewHighRiseMidRiseProjects } from './4HighRiseMidRiseProjects/servicesOverview';
import { featureDataHighRiseMidRiseProjects } from './4HighRiseMidRiseProjects/featureData';

import { MainCommercialInteriorPainting } from './5CommercialInteriorPainting/Main';
import { gallerySectionCommercialInteriorPainting } from './5CommercialInteriorPainting/gallerySection';
import { overlaySectionCommercialInteriorPainting } from './5CommercialInteriorPainting/overlaySection';
import { servicesOverviewCommercialInteriorPainting } from './5CommercialInteriorPainting/servicesOverview';
import { featureDataCommercialInteriorPainting } from './5CommercialInteriorPainting/featureData';

import { MainCommercialsnowRemoval } from './6CommercialsnowRemoval/Main';
import { gallerySectionCommercialsnowRemoval } from './6CommercialsnowRemoval/gallerySection';
import { overlaySectionCommercialsnowRemoval } from './6CommercialsnowRemoval/overlaySection';
import { servicesOverviewCommercialsnowRemoval } from './6CommercialsnowRemoval/servicesOverview';
import { featureDataCommercialsnowRemoval } from './6CommercialsnowRemoval/featureData';

import { MaingeneralContracting } from './7generalContracting/Main';
import { gallerySectiongeneralContracting } from './7generalContracting/gallerySection';
import { overlaySectiongeneralContracting } from './7generalContracting/overlaySection';
import { servicesOverviewgeneralContracting } from './7generalContracting/servicesOverview';
import { featureDatageneralContracting } from './7generalContracting/featureData';

import { MainConcreteRestoration } from './8concreteRestoration/Main';
import { gallerySectionConcreteRestoration } from './8concreteRestoration/gallerySection';
import { overlaySectionConcreteRestoration } from './8concreteRestoration/overlaySection';
import { servicesOverviewConcreteRestoration } from './8concreteRestoration/servicesOverview';
import { featureDataConcreteRestoration } from './8concreteRestoration/featureData';

import { MainBalconyRenewal } from './9BalconyRenewal/Main';
import { gallerySectionBalconyRenewal } from './9BalconyRenewal/gallerySection';
import { overlaySectionBalconyRenewal } from './9BalconyRenewal/overlaySection';
import { servicesOverviewBalconyRenewal } from './9BalconyRenewal/servicesOverview';
import { featureDataBalconyRenewal } from './9BalconyRenewal/featureData';

import { MainLeakInvestigationAndRemediation } from './10LeakInvestigationAndRemediation/Main';
import { gallerySectionLeakInvestigationAndRemediation } from './10LeakInvestigationAndRemediation/gallerySection';
import { overlaySectionLeakInvestigationAndRemediation } from './10LeakInvestigationAndRemediation/overlaySection';
import { servicesOverviewLeakInvestigationAndRemediation } from './10LeakInvestigationAndRemediation/servicesOverview';
import { featureDataLeakInvestigationAndRemediation } from './10LeakInvestigationAndRemediation/featureData';

import { featureDataWindowsCleaning } from './11WindowsCleaning/featureData';
import { servicesOverviewWindowsCleaning } from './11WindowsCleaning/servicesOverview';
import { MainWindowsCleaning } from './11WindowsCleaning/Main';
import { gallerySectionWindowsCleaning } from './11WindowsCleaning/gallerySection';
import { overlaySectionWindowsCleaning } from './11WindowsCleaning/overlaySection';

import { MainWaterproofingSystems } from './12WaterproofingSystems/Main';
import { gallerySectionWaterproofingSystems } from './12WaterproofingSystems/gallerySection';
import { overlaySectionWaterproofingSystems } from './12WaterproofingSystems/overlaySection';
import { servicesOverviewWaterproofingSystems } from './12WaterproofingSystems/servicesOverview';
import { featureDataWaterproofingSystems } from './12WaterproofingSystems/featureData';

export const servicesConfig = {
    'building-envelope-renewals': {
        mainConfig: MainBuildingEnvelopeRenewals,
        gallery: gallerySectionBuildingEnvelopeRenewals,
        overlay: overlaySectionBuildingEnvelopeRenewals,
        overview: servicesOverviewBuildingEnvelopeRenewals,
        features: featureDataBuildingEnvelopeRenewals,
    },
    'caulking-sealant-renewal': {
        mainConfig: MainServiceSectionCaulkingSealantRenewal,
        gallery: gallerySection,
        overlay: overlaySectionCaulkingSealantRenewal,
        overview: servicesOverview,
        features: featureData,
    },
    'commercial-exterior-painting': {
        mainConfig: MainCommercialExteriorPainting,
        gallery: gallerySectionCommercialExteriorPainting,
        overlay: overlaySectionCommercialExteriorPainting,
        overview: servicesOverviewCommercialExteriorPainting,
        features: featureDataCommercialExteriorPainting,
    },
    'high-rise-mid-rise-projects': {
        mainConfig: MainHighRiseMidRiseProjects,
        gallery: gallerySectionHighRiseMidRiseProjects,
        overlay: overlaySectionHighRiseMidRiseProjects,
        overview: servicesOverviewHighRiseMidRiseProjects,
        features: featureDataHighRiseMidRiseProjects,
    },
    'commercial-interior-painting': {
        mainConfig: MainCommercialInteriorPainting,
        gallery: gallerySectionCommercialInteriorPainting,
        overlay: overlaySectionCommercialInteriorPainting,
        overview: servicesOverviewCommercialInteriorPainting,
        features: featureDataCommercialInteriorPainting,
    },
    'commercial-snow-removal': {
        mainConfig: MainCommercialsnowRemoval,
        gallery: gallerySectionCommercialsnowRemoval,
        overlay: overlaySectionCommercialsnowRemoval,
        overview: servicesOverviewCommercialsnowRemoval,
        features: featureDataCommercialsnowRemoval,
    },
    'general-contracting': {
        mainConfig: MaingeneralContracting,
        gallery: gallerySectiongeneralContracting,
        overlay: overlaySectiongeneralContracting,
        overview: servicesOverviewgeneralContracting,
        features: featureDatageneralContracting,
    },
    'concrete-restoration': {
        mainConfig: MainConcreteRestoration,
        gallery: gallerySectionConcreteRestoration,
        overlay: overlaySectionConcreteRestoration,
        overview: servicesOverviewConcreteRestoration,
        features: featureDataConcreteRestoration,
    },
    'balcony-renewal': {
        mainConfig: MainBalconyRenewal,
        gallery: gallerySectionBalconyRenewal,
        overlay: overlaySectionBalconyRenewal,
        overview: servicesOverviewBalconyRenewal,
        features: featureDataBalconyRenewal,
    },
    'leak-investigation-and-remediation': {
        mainConfig: MainLeakInvestigationAndRemediation,
        gallery: gallerySectionLeakInvestigationAndRemediation,
        overlay: overlaySectionLeakInvestigationAndRemediation,
        overview: servicesOverviewLeakInvestigationAndRemediation,
        features: featureDataLeakInvestigationAndRemediation,
    },
    'windows-cleaning': {
        mainConfig: MainWindowsCleaning,
        gallery: gallerySectionWindowsCleaning,
        overlay: overlaySectionWindowsCleaning,
        overview: servicesOverviewWindowsCleaning,
        features: featureDataWindowsCleaning,
    },
    'waterproofing-systems': {
        mainConfig: MainWaterproofingSystems,
        gallery: gallerySectionWaterproofingSystems,
        overlay: overlaySectionWaterproofingSystems,
        overview: servicesOverviewWaterproofingSystems,
        features: featureDataWaterproofingSystems,
    },
};